import clsx from 'clsx'
import { ASSISTANT_INTERIM_TEXT_CLASS } from 'tripPlanner/components/Chat/useAssistantThoughtFocus'
import { useMemo } from 'react'
import styled from 'styled-components'
import MarkdownRender from 'LuxKit/MarkdownRender'
import { Heading4Style, Heading5Style } from 'LuxKit/Typography/Heading'
import { stripContextTags } from 'tripPlanner/utils/contextTag'
import { preprocessChatMarkdown } from 'tripPlanner/utils/chatMarkdown'

const Wrapper = styled.div`
  h2 { ${Heading4Style} }
  h3 { ${Heading5Style} }
`

interface Props {
  content: string
  isInterim?: boolean
}

function DrawerAskAIText({ content, isInterim = false }: Props) {
  const markdown = useMemo(() => preprocessChatMarkdown(stripContextTags(content)), [content])
  return (
    <Wrapper className={clsx(isInterim && ASSISTANT_INTERIM_TEXT_CLASS)}>
      <MarkdownRender content={markdown} fontSize="medium" type="compact" />
    </Wrapper>
  )
}

export default DrawerAskAIText
